<!-- 脚部组件 -->
<template>
  <!-- ../imgs/wxcode.png -->
  <div class="foot">
    <div class="left">
      <img class="logo" src="@/imgs/foot-logo.png" alt="">
      <img class="code" src="@/imgs/wxcode.png" alt="">
      <span>微信公众号</span>
      <p>浙数图影科技（杭州）有限公司 | 电话：0571-58421085</p>
      <a href="https://beian.miit.gov.cn">
        <p>浙ICP备2020033042号-2 | 增值电信业务经营许可证：浙B2-20201549 图影数字科技© All Rights Reserved 版权所有</p>
      </a>
    </div>
    <div class="right">
      <div class="list1">
        <h5>关于云上世界</h5>
        <span @click="go('1', 'one')">关于我们</span>
        <span @click="go('3', 'one')">用户协议</span>
        <span @click="go('4', 'one')">商业合作</span>
        <span @click="$router.push('/vip')">套餐价格</span>
        <span @click="go('2', 'one')">加入我们</span>
      </div>
      <div class="list1">
        <h5>常见问题</h5>
        <span @click="go('1', 'two')">热门问题</span>
        <span @click="go('2', 'two')">授权相关</span>
        <span @click="go('3', 'two')">购买相关</span>
        <span @click="go('4', 'two')">网站功能</span>
      </div>
      <div class="list1">
        <h5>主要产品</h5>
        <span @click="$router.push('/gallery')">共享&精品图片</span>
        <span @click="$router.push('/videosource')">共享&精品视频</span>
        <span @click="$router.push('/marketing')">数字影像馆</span>
        <span @click="$router.push('/marketing')">VR全景飞阅体验</span>
      </div>
      <div class="list1">
        <h5>联系&支持</h5>
        <span style="font-weight: bold;color: #fff;">购买咨询&nbsp;&nbsp; <i
            style="color: #E4E4E4;font-weight: normal;">0571-5842 1058</i></span>
        <img class="code" src="@/imgs/code1.png" alt="">
        <span style="font-weight: bold;color: #fff;">供稿咨询</span>
        <img src="@/imgs/code2.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "foot",
  data() {
    return {};
  },
  methods: {
    go(a, t) {
      this.$router.push({
        path: '/about',
        query: {
          type: t,
          active: a
        }
      })
    }
  }
};
</script>
<style scoped lang="scss">
.foot {
  background: url(../imgs/foot-bg.jpg) no-repeat;
  background-size: cover;
  margin-top: 40px;
  width: 100%;
  height: 375px;
  background-color: #39393c;
  padding: 30px 40px 0px 120px;
  display: flex;
  justify-content: space-between;

  .left {
    width: 730px;
    height: 100%;
    margin-right: 90px;
    display: flex;
    flex-direction: column;

    .logo {
      width: 135px;
      height: 30px;
      margin-bottom: 38px;
    }

    .code {
      margin-bottom: 11px;
      width: 80px;
      height: 80px;
    }

    span {
      width: 80px;
      text-align: center;
      margin-bottom: 70px;
      color: #E4E4E4;
      font-size: 14px;
    }

    p {
      color: #C5C5C5;
      font-size: 12px;
    }
  }

  .right {
    height: 100%;
    width: 850px;
    display: flex;
    justify-content: space-between;

    .list1 {
      cursor: pointer;
      height: 100%;
      width: 25%;
      display: flex;
      flex-direction: column;

      img {
        width: 80px;
        height: 80px;
      }

      .code {
        margin-bottom: 15px;
      }

      h5 {
        margin-bottom: 20px;
        font-size: 16px;
        color: #fff;
      }

      span {
        font-size: 14px;
        color: #999;
        margin-bottom: 10px;
        transition: all 0.3s;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/foot.vue